import styled from '@emotion/styled';
import { STextOverflowCss } from '@shared/styles/styledComponentsCommon';
import { MenuDropdown } from '@shared/ui/index';

export const SMenuDropdown = styled(MenuDropdown)<{ $haveItems?: boolean }>`
  margin-top: -9px;
  position: absolute;
  width: ${(props) => (props.$haveItems ? '233px' : '0')};
  ${(props) => !props.$haveItems && 'box-shadow:none'};
`;

export const SCity = styled(STextOverflowCss)`
  max-width: 270px;
  max-height: 22px;
`;
